// Translations
import landing from '../views/landing/translations/ru'

// Translation: Reset (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
